/**
 * Receive a string and remove elements according to
 * the defined limit. Defaul (10)
 * @param label - Label to split
 * @param limit - Lax length
 * @returns - Splitted label
 */
export function splitStringByLength(label: string, limit = 17): string {
  if (label.length < limit) return label;

  return `${label.substring(0, limit - 3)}...`;
}

export default splitStringByLength;
